import { navigate } from '~/router';
import { OrganizationType, UserRole } from './consts';


export const redirectToHome = (user, org) => {
  console.log(user, org);

  switch (org.orgType) {
    case OrganizationType.ADMIN:
      switch (user.role) {
        case UserRole.ADMIN:
          navigate('admin');
          break;
        case UserRole.SUPPORT:
          navigate('support');
          break;
        default:
          console.log(`User role "${user.role}" is missing for organization type "${OrganizationType.ADMIN}"`);
          break;
      }
      break;
    case OrganizationType.CARRIER:
      navigate('sender');
      break;
    case OrganizationType.UNLOADER:
      switch (user.role) {
        case UserRole.CLERK:
          return navigate('receiver.mobile');
        case UserRole.AGENT:
          return navigate('receiver.admin');
      }
      break;
    case OrganizationType.POS:
      switch (user.role) {
        case UserRole.CLERK:
          return navigate('pos.mobile');
        case UserRole.AGENT:
        case UserRole.WAREHOUSE_MANAGER:
          return navigate('pos.admin');
      }
      break;
    default:
      console.log(`Organization type "${org.orgType}" is missing`);
      break
  }
};
